<template>
  <div>


    <div v-if="$store.state.searchShow">
      <search></search>
    </div>


    <van-nav-bar style="height: 89px;" :border="false" :fixed="true">
      <template #title>
        <div class="switch">

          <div @click="goInfo" :class="$store.state.strategyTitle===0?'infoButtonOn':'infoButton'"><span
              :class="$store.state.strategyTitle===0?'infoTextOn':'infoText'">资讯</span></div>
          <div @click="goSt" :class="$store.state.strategyTitle===1?'stButtonOn':'stButton'"><span
              :class="$store.state.strategyTitle===1?'stTextOn':'stText'">策略</span></div>

        </div>

      </template>
      <template #right>
        <div style="position: absolute;top:55px;right: 15px"
             @click="$store.state.menuOpen = false;$store.state.menuShow = false;$store.state.searchShow=true;">
          <svg-icon icon-class="search" style="width:20px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <!--&lt;!&ndash;    <div v-show="this.$store.state.strategyTitle"><information></information></div>&ndash;&gt;-->
    <!--&lt;!&ndash;    <div v-show="!this.$store.state.strategyTitle"><strategy-list></strategy-list></div>&ndash;&gt;-->

    <div v-show="!$store.state.searchShow">
      <div v-if="$store.state.searchLock">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>

import search from "@/components/search/search";

export default {
  name: "strategyTitle",
  components: {search},
  data() {
    return {}
  },
  methods: {
    goInfo() {
      if (this.$route.path !== '/strategy/information') {
        this.$router.push('/strategy/information');
        this.$store.state.strategyTitle = 0;
      }
    },
    goSt() {
      if (this.$route.path !== '/strategy/strategy') {
        this.$router.push('/strategy/strategy');
        this.$store.state.strategyTitle = 1;
      }
    },
    checkUrl() {
      if (this.$store.state.strategyTitle === 0) {
        this.$router.push('/strategy/information');
      } else if (this.$store.state.strategyTitle === 1) {
        this.$router.push('/strategy/strategy');
      }
    }
  },
  created() {
    this.checkUrl()
  }
}
</script>

<style scoped>
.switch {
  display: flex;
  width: 112px;
  position: absolute;
  top: 50px;
  margin-left: -56px;

}

.infoButton {
  width: 55px;
  height: 28px;
  color: #93a2b8;
  border: 1px solid;
  border-right: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.infoButtonOn {
  width: 55px;
  height: 28px;
  color: #1875f8;
  background-color: #1875f8;
  border: 1px solid;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.stButton {
  width: 55px;
  height: 28px;
  color: #93a2b8;
  border: 1px solid;
  border-left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

}

.stButtonOn {
  width: 55px;
  height: 28px;
  color: #1875f8;
  background-color: #1875f8;
  border: 1px solid;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;


}


.infoText {
  line-height: 30px;
}

.infoTextOn {
  line-height: 30px;
  color: white;
  font-weight: bolder;

}

.stText {
  line-height: 30px;
}

.stTextOn {
  line-height: 30px;
  color: white;
  font-weight: bolder;
}


</style>
